export var KeyboardEventCodes = /*#__PURE__*/function (KeyboardEventCodes) {
  KeyboardEventCodes["Unidentified"] = "Unidentified";
  KeyboardEventCodes["Escape"] = "Escape";
  KeyboardEventCodes["KeyA"] = "KeyA";
  KeyboardEventCodes["KeyC"] = "KeyC";
  KeyboardEventCodes["KeyV"] = "KeyV";
  KeyboardEventCodes["KeyX"] = "KeyX";
  KeyboardEventCodes["Enter"] = "Enter";
  KeyboardEventCodes["Tab"] = "Tab";
  KeyboardEventCodes["CapsLock"] = "CapsLock";
  KeyboardEventCodes["Minus"] = "Minus";
  KeyboardEventCodes["Equal"] = "Equal";
  KeyboardEventCodes["Backspace"] = "Backspace";
  KeyboardEventCodes["Comma"] = "Comma";
  KeyboardEventCodes["Period"] = "Period";
  KeyboardEventCodes["Slash"] = "Slash";
  KeyboardEventCodes["Backslash"] = "Backslash";
  KeyboardEventCodes["IntlBackslash"] = "IntlBackslash";
  KeyboardEventCodes["Space"] = "Space";
  KeyboardEventCodes["Home"] = "Home";
  KeyboardEventCodes["End"] = "End";
  KeyboardEventCodes["Insert"] = "Insert";
  KeyboardEventCodes["Delete"] = "Delete";
  KeyboardEventCodes["PageUp"] = "PageUp";
  KeyboardEventCodes["PageDown"] = "PageDown";
  KeyboardEventCodes["NumpadDivide"] = "NumpadDivide";
  KeyboardEventCodes["NumpadSubtract"] = "NumpadSubtract";
  KeyboardEventCodes["NumpadDecimal"] = "NumpadDecimal";
  KeyboardEventCodes["NumpadEnter"] = "NumpadEnter";
  return KeyboardEventCodes;
}({});